export const SUPPLIER_REQUEST_STATUS = {
    ACTIVE: 0,
    DONE: 1,
    DELETED: 2,
} as const;

export const DEFAULT_SUPPLIER_REQUEST_STATUSES = [SUPPLIER_REQUEST_STATUS.ACTIVE];

export const SUPPLIER_REQUESTS_PAGE_SIZE_KEY = 'supplier-requests';

export const SUPPLIER_REQUEST_NOTE_MAX_LENGTH = 300;
